import { apiSlice } from "../../app/api/apiSlice";

export const applicationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		updateLoanWithProduct: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/update_ob_pricing/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useUpdateLoanWithProductMutation } = applicationApiSlice;
